export const environment = {
  production: true,
  register: true,
  pitchSection: true,
  positionReport: false,
  callToAction: true,
  protectionSection: false,
  actionExample: false,
  shouldShowProductDetail: false,
  showAdvancedProfile: true,
  showLogo: true,
  clientLogo: false,
  noLawModal: true,
  cssPath: './assets/client/esgsan-web-santander-dev/css/client.css',
  api: {
    baseUrl: "https://banorte.api.dev.newinvest.io/api/v1/",
    countries: "regions",
    businesses: "businesses",
    interlocutors: "interlocutors",
    risks: "risks",
  },
  availablePageSizes: [5, 10, 20, 50, 100],
  auth: {
    issuer:
      "https://valora-idp.azurewebsites.net/realms/esg-banorte-dev",
    clientId: "esg-web-dev",
    tokenEndpoint:
      "https://valora-idp.azurewebsites.net/realms/esg-banorte-dev/protocol/openid-connect/token",
    userInfoEndpoint:
      "https://valora-idp.azurewebsites.net/realms/esg-banorte-dev/protocol/openid-connect/userinfo",
    requireHttps: false,
    allowedUrls: [
      "https://banorte.api.dev.newinvest.io/",
      "http://banorte.api.dev.newinvest.io/",
      "https://localhost:7036/",
    ],
  },
};
